import { css, html } from 'react-strict-dom';
import { FieldProp } from 'react-typed-form';
import { ErrorList, RadioButton, Stack, Text } from 'src/components';
import { Style } from 'src/constants';

type Props = {
  field: FieldProp<string | null>;
  label?: string;
  disabled?: boolean;
  options: {
    value: string;
    label: string;
  }[];
};

export default function FieldRadioGroup({
  field,
  label,
  disabled,
  options,
}: Props) {
  const isDisabled = disabled || field.isLoading;

  return (
    <Stack gap={0.5}>
      <Text
        typeface="body.small.regular"
        color={isDisabled ? 'neutral60' : 'neutral80'}
      >
        {label ?? field.label}
      </Text>
      <Stack style={[Style.row, Style.alignCenter, styles.options]} gap={1}>
        {options.map((option) => (
          <html.div
            key={option.value}
            onClick={
              isDisabled
                ? undefined
                : () => field.handleValueChange(option.value)
            }
          >
            <Stack style={[Style.row, Style.alignCenter]} gap={0.5}>
              <RadioButton
                selected={field.value === option.value}
                disabled={isDisabled}
              />
              <Text
                typeface="body.regular"
                color={isDisabled ? 'neutral60' : 'neutral100'}
              >
                {option.label}
              </Text>
            </Stack>
          </html.div>
        ))}
      </Stack>
      <ErrorList errors={field.lastErrorList} />
    </Stack>
  );
}

const styles = css.create({
  options: {
    flexDirection: {
      default: 'row',
      '@media (max-width: 768px)': 'column',
    },
    alignItems: {
      default: 'center',
      '@media (max-width: 768px)': 'flex-start',
    },
  },
});
